var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isVisible
    ? _c(
        "div",
        {
          staticClass: "form-item checkbox",
          class: [_vm.item.data.htmloptions, { "is-invalid": _vm.isInvalid }],
        },
        [
          _vm.item.data.question != ""
            ? _c("Label", {
                attrs: { item: _vm.item, "is-invalid": _vm.isInvalid },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.answeroptions, function (answer) {
            return _c("div", { key: answer.id, staticClass: "checkbox-item" }, [
              _c("input", {
                attrs: {
                  type: "checkbox",
                  id: answer.id,
                  name: _vm.singleCheckbox
                    ? _vm.item.data.id
                    : `${_vm.item.data.id}[]`,
                },
                domProps: {
                  value: answer.value,
                  checked: _vm.isChecked(answer),
                },
                on: {
                  change: function ($event) {
                    return _vm.updateFormValue(
                      $event,
                      _vm.item.data.uniqlabel,
                      answer.value
                    )
                  },
                },
              }),
              _vm._v(" "),
              _c("i", { staticClass: "icon-form-checkmark" }),
              _vm._v(" "),
              _c("label", { attrs: { for: answer.id } }, [
                _vm._v(" " + _vm._s(answer.label)),
              ]),
            ])
          }),
          _vm._v(" "),
          _vm.errorMessage
            ? _c("error-message", [_vm._v(_vm._s(_vm.errorMessage))])
            : _vm._e(),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }